import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "toggle-header", class: _vm.params.headerClass },
    [
      _vm._v("\n  " + _vm._s(_vm.params.headerName) + "\n  "),
      _vm.params.enableToggle
        ? _c(
            "div",
            { staticClass: "toggle ml-4 mr-2 mb-2" },
            [
              _c(
                "tooltip",
                {
                  attrs: {
                    value: _vm.tooltipValue,
                    disabled: !_vm.tooltipValue,
                  },
                },
                [
                  _c(VSwitch, {
                    staticClass: "mr-2 pt-0",
                    attrs: {
                      "input-value": _vm.initialValue,
                      disabled: _vm.params.isDisabled(),
                      primary: "",
                      dense: "",
                      "hide-details": "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.toggle($event)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.params.toggleLabel) +
                                  "\n          "
                              ),
                              _c(
                                VIcon,
                                { attrs: { size: "1.8rem", right: "" } },
                                [_vm._v(_vm._s(_vm.params.toggleIcon))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1674050295
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }